export type AbortTimeoutOptions = {
  label?: string;
};

export async function withAbortTimeout<T>(
  ms: number,
  task: (signal: AbortSignal) => PromiseLike<T>,
  options: AbortTimeoutOptions = {}
): Promise<T> {
  const label = options.label ?? 'Operation';
  const controller = new AbortController();

  let timeoutId: number | undefined;
  const timeoutPromise = new Promise<never>((_, reject) => {
    timeoutId = window.setTimeout(() => {
      controller.abort();
      reject(new Error(`${label} timed out after ${Math.round(ms / 1000)}s`));
    }, ms);
  });

  try {
    const taskPromise = Promise.resolve(task(controller.signal) as any) as Promise<T>;
    return await Promise.race([taskPromise, timeoutPromise]);
  } finally {
    if (timeoutId) window.clearTimeout(timeoutId);
  }
}
